import { AppStates } from "utils/helpers/app.helpers";
import withProtectedRoute from "utils/hocs/withProtectedRoute";
import SelectTimeframeContainer from "../../../containers/MyGps/SelectTimeframeContainer/SelectTimeframeContainer";

const SelectTimeframeScreen = () => {
  return <SelectTimeframeContainer />
}

export default withProtectedRoute(SelectTimeframeScreen, AppStates.homeState);
